module.exports = __webpack_public_path__ + "static/img/stock-photo-welcome-to-my-shop-shot-of-a-beautiful-female-baker-posing-in-the-bakery-store-369336572.f45f3a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stock-photo-welcome-to-my-shop-shot-of-a-beautiful-female-baker-posing-in-the-bakery-store-369336572.jpg
// module id = A1cL
// module chunks = 1